import React from "react";
import {
  Collapse,
  Box,
  Typography,
  Grid,
  CircularProgress,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faLightbulb,
  faQuoteRight,
} from "@fortawesome/free-solid-svg-icons";

const Maxims = ({ isOpen, loading, data, activeSection }) => {
  return (
    <Collapse in={isOpen}>
      <Box sx={{ mt: 1, pt: 1, borderTop: "1px solid rgba(0, 0, 0, 0.06)" }}>
        {loading && activeSection === "maxims" ? (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress size={16} />
          </Box>
        ) : (
          activeSection === "maxims" && (
            <Box
              sx={{
                mb:
                  activeSection === "terms" || activeSection === "phrases"
                    ? 1
                    : 0,
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  color: "#92400E",
                  mb: 0.5,
                }}
              >
                Maxims
              </Typography>
              <Grid container spacing={0.5}>
                {Object.entries(data?.Maxims || {})?.map(
                  ([key, value], index) => (
                    <Grid item xs={12} key={index}>
                      <Box
                        sx={{
                          p: 0.75,
                          borderRadius: "6px",
                          backgroundColor: "rgba(245, 158, 11, 0.03)",
                          border: "1px solid rgba(245, 158, 11, 0.1)",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            backgroundColor: "rgba(245, 158, 11, 0.05)",
                            transform: "translateY(-1px)",
                            boxShadow: "0 2px 4px rgba(245, 158, 11, 0.1)",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 0.75,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "18px",
                              height: "18px",
                              borderRadius: "4px",
                              backgroundColor: "rgba(245, 158, 11, 0.1)",
                              transition: "all 0.2s ease",
                              flexShrink: 0,
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faLightbulb}
                              style={{
                                fontSize: "0.65rem",
                                color: "#F59E0B",
                              }}
                            />
                          </Box>
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                              sx={{
                                fontSize: "0.75rem",
                                fontWeight: 500,
                                color: "#B45309",
                                mb: 0.25,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {key}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "0.7rem",
                                color: "#4B5563",
                                lineHeight: 1.4,
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {value}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  )
                )}
              </Grid>
            </Box>
          )
        )}

        {loading && activeSection === "terms" ? (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress size={16} />
          </Box>
        ) : (
          activeSection === "terms" && (
            <Box sx={{ mb: activeSection === "phrases" ? 1 : 0 }}>
              <Typography
                sx={{
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  color: "#1E40AF",
                  mb: 0.5,
                }}
              >
                Terms
              </Typography>
              <Grid container spacing={0.5}>
                {Object.entries(data?.Legal_Terms || {})?.map(
                  ([key, value], index) => (
                    <Grid item xs={12} key={index}>
                      <Box
                        sx={{
                          p: 0.75,
                          borderRadius: "6px",
                          backgroundColor: "rgba(37, 99, 235, 0.03)",
                          border: "1px solid rgba(37, 99, 235, 0.1)",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            backgroundColor: "rgba(37, 99, 235, 0.05)",
                            transform: "translateY(-1px)",
                            boxShadow: "0 2px 4px rgba(37, 99, 235, 0.1)",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 0.75,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "18px",
                              height: "18px",
                              borderRadius: "4px",
                              backgroundColor: "rgba(37, 99, 235, 0.1)",
                              transition: "all 0.2s ease",
                              flexShrink: 0,
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faBook}
                              style={{
                                fontSize: "0.65rem",
                                color: "#2563EB",
                              }}
                            />
                          </Box>
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                              sx={{
                                fontSize: "0.75rem",
                                fontWeight: 500,
                                color: "#1E40AF",
                                mb: 0.25,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {key}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "0.7rem",
                                color: "#4B5563",
                                lineHeight: 1.4,
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {value}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  )
                )}
              </Grid>
            </Box>
          )
        )}

        {loading && activeSection === "phrases" ? (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress size={16} />
          </Box>
        ) : (
          activeSection === "phrases" && (
            <Box>
              <Typography
                sx={{
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  color: "#5B21B6",
                  mb: 0.5,
                }}
              >
                Words & Phrases
              </Typography>
              <Grid container spacing={0.5}>
                {Object.entries(data?.Words_and_Phrases || {})?.map(
                  ([key, value], index) => (
                    <Grid item xs={12} key={index}>
                      <Box
                        sx={{
                          p: 0.75,
                          borderRadius: "6px",
                          backgroundColor: "rgba(124, 58, 237, 0.03)",
                          border: "1px solid rgba(124, 58, 237, 0.1)",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            backgroundColor: "rgba(124, 58, 237, 0.05)",
                            transform: "translateY(-1px)",
                            boxShadow: "0 2px 4px rgba(124, 58, 237, 0.1)",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 0.75,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "18px",
                              height: "18px",
                              borderRadius: "4px",
                              backgroundColor: "rgba(124, 58, 237, 0.1)",
                              transition: "all 0.2s ease",
                              flexShrink: 0,
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faQuoteRight}
                              style={{
                                fontSize: "0.65rem",
                                color: "#7C3AED",
                              }}
                            />
                          </Box>
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography
                              sx={{
                                fontSize: "0.75rem",
                                fontWeight: 500,
                                color: "#5B21B6",
                                mb: 0.25,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {key}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "0.7rem",
                                color: "#4B5563",
                                lineHeight: 1.4,
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {value}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  )
                )}
              </Grid>
            </Box>
          )
        )}
      </Box>
    </Collapse>
  );
};

export default Maxims;
